export default __webpack_public_path__ + "static/media/career-tour.6bb81b24.jpg";